import React from "react";
import { Phone, FileText, Star, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustedCollisionRepair() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="9430" id="expert-caravan-restoration-in-south-windsor" ref={sectionRef} className="dark bg-[hsl(222,47%,6%)] text-foreground relative min-h-[85vh] flex items-center overflow-hidden py-16 lg:py-0">
      {}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599594/img/dark_mesh_texture.png)] bg-fixed bg-cover bg-center mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div className="container mx-auto px-4 relative z-10 h-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 h-full">
          
          {}
          <div className={`flex-1 lg:w-[60%] space-y-8 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[hsl(217,91%,60%)]/10 border border-[hsl(217,91%,60%)]/20 text-[hsl(217,91%,60%)] text-sm font-medium tracking-wide uppercase">
                <Star className="w-4 h-4 fill-[hsl(217,91%,60%)]" />
                <span>#1 Caravan Repair in Sydney</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-[80px] font-extrabold tracking-tight leading-[1.05]">
                Expert Caravan <br />
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-[hsl(217,91%,60%)] via-blue-400 to-[hsl(24,95%,53%)] animate-gradient-x">
                  Restoration
                </span>
                <br />
                in <span className="text-[hsl(217,91%,60%)]">South Windsor</span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed font-medium">
                Specializing in insurance and private repairs. We restore your caravan to optimal condition with industrial precision, from hail damage to structural restorations.
              </p>

              <div className="flex flex-wrap gap-3 text-sm font-mono text-muted-foreground">
                {["Insurance & Private", "Hail Damage Specialist", "Structural Repairs"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2 bg-[hsl(222,47%,11%)] px-3 py-1.5 rounded-sm border border-border/50">
                    <CircleCheck className="w-4 h-4 text-[hsl(217,91%,60%)]" />
                    {item}
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="bg-[hsl(24,95%,53%)] hover:bg-[hsl(24,95%,48%)] text-white border-none shadow-[0_0_20px_rgba(249,115,22,0.3)] hover:shadow-[0_0_30px_rgba(249,115,22,0.5)] transition-all duration-300 text-base h-14 px-8 rounded-sm">
                <Link to="/StartYourQuotePage">
                  <FileText className="mr-2 h-5 w-5" />
                  Start Your Quote
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-white/30 text-white hover:bg-white/10 hover:border-white hover:text-white transition-all duration-300 text-base h-14 px-8 backdrop-blur-sm rounded-sm">
                <Link to="/CaravanMotorhomeServicingInSydneyPage">
                  <Star className="mr-2 h-5 w-5" />
                  View Our Work
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`flex-1 lg:w-[40%] relative h-full min-h-[400px] lg:min-h-[600px] w-full flex items-center justify-center transition-all duration-1000 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="relative w-full h-full max-h-[700px] rounded-xl overflow-hidden shadow-2xl border border-white/10 group">
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-[hsl(222,47%,6%)]/80 to-transparent z-10 !bg-[url(https://climbing-camel.10web.cloud/wp-content/uploads/2026/03/kunakia_featured_offering.webp)]" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599594/img/luxury_car_fender_reflection.png" alt="Expert caravan restoration in our South Windsor workshop" className="w-full h-full object-cover object-center scale-105 group-hover:scale-110 transition-transform duration-700 ease-in-out" />
              
              {}
              <div className="absolute bottom-8 left-8 right-8 z-20">
                <div className="bg-[hsl(222,47%,11%)]/40 backdrop-blur-xl border border-white/10 p-6 rounded-lg shadow-[0_8px_32px_rgba(0,0,0,0.5)] flex items-center justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-1 mb-1">
                      {[1, 2, 3, 4, 5].map((star, i) => <Star key={i} data-index={i} className="w-5 h-5 fill-[hsl(24,95%,53%)] text-[hsl(24,95%,53%)]" />)}
                    </div>
                    <p className="font-bold text-white text-lg font-sans">5-Star Rated</p>
                    <p className="text-sm text-white/70 font-mono">"Outstanding attention to detail."</p>
                  </div>
                  <div className="h-12 w-12 rounded-full bg-[hsl(217,91%,60%)]/20 flex items-center justify-center border border-[hsl(217,91%,60%)]/30 shrink-0">
                    <CircleCheck className="w-6 h-6 text-[hsl(217,91%,60%)]" />
                  </div>
                </div>
              </div>
            </div>

            {}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[hsl(217,91%,60%)]/10 rounded-full blur-[100px] -z-10" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[hsl(24,95%,53%)]/10 rounded-full blur-[100px] -z-10" />
          </div>

        </div>
      </div>
    </section>;
}